export default __webpack_public_path__ + "static/media/footer.f5b3d569.svg";